import React, { memo } from 'react';
import { ValidationErrors } from 'constants/validations';
import { BrandSelect, TagSelect } from 'components/common';
import { Col, Form, FormModal, Input, Row } from 'components';
import { useItemDetailsEdit } from 'pages/admin/items/item/details/edit/useItemDetailsEdit';

const { Item } = Form;
const { TextArea } = Input;

export interface IBrandDetailsUpdate {
  onCancel: () => void;
  open?: boolean;
}

export const ItemDetailsEdit = memo<IBrandDetailsUpdate>((props) => {
  const [form] = Form.useForm();
  const { onCancel, open } = props;

  const { onFinish, tagData, onCancelModal, isLoading } = useItemDetailsEdit({
    onCancel,
    form,
    open,
  });

  return (
    <FormModal
      form={form}
      title={'Update Item'}
      okText={'Save'}
      open={open}
      isLoading={isLoading}
      onCancel={onCancelModal}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Item
            label={'Item SKU*'}
            name={'itemSKU'}
            rules={[{ required: true, message: ValidationErrors.required('Item SKU') }]}
          >
            <Input size={'large'} />
          </Item>
        </Col>
        <Col span={12}>
          <Item
            label={'Brand*'}
            name={'brandId'}
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Brand'),
              },
            ]}
          >
            <BrandSelect size={'large'} maxTagCount={'responsive'} />
          </Item>
        </Col>
        <Col span={24}>
          <Item label={'Description'} name={'description'}>
            <TextArea style={{ resize: 'none' }} rows={4} size={'large'} />
          </Item>
        </Col>
        <Col span={24}>
          <TagSelect data={tagData} name={'manualTags'} label={'Tags'} />
        </Col>
        <Col span={24}>
          <Item label={'Additional Notes'} name={'additionalNotes'}>
            <TextArea rows={4} />
          </Item>
        </Col>
      </Row>
    </FormModal>
  );
});
